import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function Field({ label, value, onChange, placeholder, testid }) {
  return (
    <div>
      <Label>{label}</Label>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-1.5 h-10 rounded-xl"
        data-testid={testid}
      />
    </div>
  );
}

export function SelectField({ label, value, onChange, options }) {
  return (
    <div>
      <Label>{label}</Label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1.5 h-10 w-full rounded-xl border border-border bg-background px-3 text-sm"
      >
        {options.map((o) => <option key={o}>{o}</option>)}
      </select>
    </div>
  );
}
